export const keywordSearch = ({
  keyword,
  categoryDataArr,
  serviceCategories,
  fileData,
}) => {
  let searchResult = [];

  const keywordIncludedCategories = categoryDataArr.filter((category) => {
    return category.name.includes(keyword);
  });

  searchResult = searchResult.concat(keywordIncludedCategories);

  const keywordIncludedServices = serviceCategories.filter((service) => {
    return service.name.includes(keyword);
  });

  if (searchResult.length === 0) {
    searchResult = searchResult.concat(keywordIncludedServices);
  } else {
    const nonDuplicateServices = keywordIncludedServices.filter((service) => {
      const isDuplicate = searchResult.find((data) => data.id === service.id);
      return !isDuplicate;
    });
    searchResult = searchResult.concat(nonDuplicateServices);
  }

  const foundResultOfFile = fileData.filter((file) => {
    return file.oldName.includes(keyword);
  });

  if (searchResult.length === 0) {
    searchResult = searchResult.concat(foundResultOfFile);
  } else {
    const nonDuplicateFiles = foundResultOfFile.filter((file) => {
      const isDuplicate = searchResult.find((data) => {
        const isDuplicateCategory = data.id === file.category;
        const isDuplicateService = data.id === file.database;
        return isDuplicateCategory || isDuplicateService;
      });
      return !isDuplicate;
    });
    searchResult = searchResult.concat(nonDuplicateFiles);
  }

  return searchResult;
};

export const getFilteredFileData = (searchResult, fileData) => {
  if (searchResult.length === 0) {
    return [];
  } else {
    const filteredData = fileData.filter((file) => {
      const foundData = searchResult.find((resultData) => {
        return (
          resultData.id === file.category ||
          resultData.id === file.database ||
          resultData._id === file._id
        );
      });
      return foundData !== undefined;
    });
    return filteredData;
  }
};
